var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v("点击侧边栏查看内容")])
}
var staticRenderFns = []

export { render, staticRenderFns }